import { addClass, addEventListenerIfNotExists, removeClass } from './common';

export default class ProductToggleCollection {
    hideClass: string = "d-none";

    recycledButtonId: string = '#product-toggle-collection-recycled-button';
    naturalButtonId: string = '#product-toggle-collection-natural-button';
    newArrivalsButtonId: string = '#product-toggle-collection-new-arrivals-button';

    newArrivalsButton: HTMLElement;
    recycledButton: HTMLElement;
    naturalButton: HTMLElement;


    recycledCollectionId: string = '#product-toggle-collection-recycled';
    naturalCollectionId: string = '#product-toggle-collection-natural';
    newArrivalsCollectionId: string = '#product-toggle-collection-new-arrivals';

    recycledCollection: HTMLElement;
    naturalCollection: HTMLElement;
    newArrivalsCollection: HTMLElement;    

    init(): void {
        this.recycledCollection = <HTMLElement>document.querySelector(this.recycledCollectionId);
        this.naturalCollection = <HTMLElement>document.querySelector(this.naturalCollectionId);
        this.newArrivalsCollection = <HTMLElement>document.querySelector(this.newArrivalsCollectionId);

        this.recycledButton = <HTMLElement>document.querySelector(this.recycledButtonId);
        this.newArrivalsButton = <HTMLElement>document.querySelector(this.newArrivalsButtonId);
        this.naturalButton = <HTMLElement>document.querySelector(this.naturalButtonId);

        this.registerButtonClickListener();
    }

    private registerButtonClickListener(): void {
        var naturalButton = <HTMLElement>document.querySelector(this.naturalButtonId);

        addEventListenerIfNotExists(this.recycledButton, "click", () => {
            this.toggleCollections(this.recycledCollection, [this.naturalCollection, this.newArrivalsCollection]);
            this.toggleButtons(this.recycledButton, [this.naturalButton, this.newArrivalsButton]);
        });

        addEventListenerIfNotExists(naturalButton, "click", () => {
            this.toggleCollections(this.naturalCollection, [this.recycledCollection, this.newArrivalsCollection]);
            this.toggleButtons(this.naturalButton, [this.recycledButton, this.newArrivalsButton]);
        });

        addEventListenerIfNotExists(this.newArrivalsButton, "click", () => {
            this.toggleCollections(this.newArrivalsCollection, [this.naturalCollection, this.recycledCollection]);
            this.toggleButtons(this.newArrivalsButton, [this.naturalButton, this.recycledButton]);
        });
    }

    private toggleCollections(element: HTMLElement, otherElements: HTMLElement[]) {
        if (element.classList.contains(this.hideClass)) {
            removeClass(element, this.hideClass);
            removeClass(element, 'active');

            otherElements.forEach(otherElement => {
                addClass(otherElement, this.hideClass)
                removeClass(otherElement, 'active');
            });
        }
    }

    private toggleButtons(element: HTMLElement, otherElements: HTMLElement[]) {
        addClass(element, 'active');

        otherElements.forEach(otherElement => {
            removeClass(otherElement, 'active');
        });
    }
}



